import { z } from "zod";
import { zReportGroupBy } from "./report.common";
/** Строка `rows` ответа `corp_report_orders` (§4.3). */
export const zCorpReportRowDto = z.object({
    key: z.string(),
    label: z.string(),
    orders: z.number(),
    kwh: z.number(),
    amount: z.number(),
});
const zCorpReportTotalsDto = z.object({
    orders: z.number(),
    kwh: z.number(),
    amount: z.number(),
});
/** Ответ `corp_report_orders` (§4.3). */
export const zCorpReportDto = z.object({
    companyId: z.string(),
    dateFrom: z.string(),
    dateTo: z.string(),
    groupBy: zReportGroupBy,
    totals: zCorpReportTotalsDto,
    rows: z.array(zCorpReportRowDto),
});
/** `vehicle` jsonb `v_corp_orders` (§4.2). */
export const zCorpOrderVehicleDto = z.object({
    brand: z.string().nullish(),
    model: z.string().nullish(),
    stateNumber: z.string().nullish(),
});
/**
 * `v_corp_orders` (обе роли, §4.2). Техник/маршрут/ETA — `null` при отменённом маршруте (CCR-036).
 */
export const zCorpOrderRowDto = z.object({
    order_id: z.string(),
    company_id: z.string(),
    link_id: z.string().nullish(),
    order_number: z.string(),
    status: z.string(),
    employee_label: z.string().nullish(),
    client_name: z.string().nullish(),
    phone_e164: z.string().nullish(),
    scheduled_date: z.string().nullish(),
    scheduled_date_end: z.string().nullish(),
    address: z.string().nullish(),
    vehicle: zCorpOrderVehicleDto.nullable(),
    plan_total_kwh: z.number().nullish(),
    plan_cost: z.number().nullish(),
    actual_total_kwh: z.number().nullish(),
    actual_cost: z.number().nullish(),
    price_per_kwh_snapshot: z.number().nullish(),
    service_fee_snapshot: z.number().nullish(),
    technician_name: z.string().nullable(),
    eta: z.string().nullable(),
    created_at: z.string(),
    charged_at: z.string().nullable(),
    is_charged: z.boolean(),
    invoice_id: z.string().nullish(),
    invoice_number: z.string().nullish(),
    client_id: z.string().nullish(),
    // `corp_my_orders` (кабинет, TECH-CORP-008) этих колонок не отдаёт — аддитивно ослаблено до `.nullish()`.
    technician_id: z.string().nullish(),
    route_id: z.string().nullish(),
});
export const CORP_ORDER_COLUMNS = "order_id,company_id,link_id,order_number,status,employee_label,client_name,phone_e164,scheduled_date,scheduled_date_end,address,vehicle,plan_total_kwh,plan_cost,actual_total_kwh,actual_cost,price_per_kwh_snapshot,service_fee_snapshot,technician_name,eta,created_at,charged_at,is_charged,invoice_id,invoice_number,client_id,technician_id,route_id";
